// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * ____   ____    .__   __
 * \\   \\ /   /___ |  |_/  |______      ____ ___.__.
 *  \\   Y   /  _ \\|  |\\   __  \\_ \\   / ___<   |  |
 *   \\     (  <_> )  |_|  |  / __ \\_/ /_/  >___  |
 *    \\___/ \\____/|____/__| (____  /\\___  // ____|
 *                               \\//_____/ \\/
 *
 * Copyright (c) 2017-2025 Voltagy. All rights reserved.
 * https://voltagy.com
 *
 * PROPRIETARY AND CONFIDENTIAL
 *
 * This source code is the proprietary and confidential property of Voltagy.
 * Unauthorized copying, transfer, or use of this file, via any medium, is
 * strictly prohibited without the express written permission of Voltagy.
 *
 * The receipt or possession of this source code and/or related information
 * does not convey or imply any right to use it, reproduce it, disclose its
 * contents, or to manufacture, use, or sell anything that it may describe.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 *
 */

.search-bar-container {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 300px;
}

.search-input {
  width: 100%;
  border-radius: 0.375rem;
  border-width: 1px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

.search-input:focus {
  --tw-border-opacity: 1;
  border-color: rgb(251 146 60 / var(--tw-border-opacity, 1));
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.search-input:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}

.search-input:focus:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(253 186 116 / var(--tw-border-opacity, 1));
}

.suggestions {
  border-radius: 0.375rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.suggestions:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

.suggestions {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin: 0;
  max-height: 50vh;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: var(--primary-color) transparent;
}

.suggestions::-webkit-scrollbar {
  width: 4px;
}

.suggestions::-webkit-scrollbar-track {
  background: transparent;
}

.suggestions::-webkit-scrollbar-thumb {
  background-color: var(--primary-color);
  border-radius: 1px;
  border: 2px solid white;
}

.suggestions li {
  padding: 10px;
  cursor: pointer;
  transition: background-color 0.2s;
  list-style-type: none;
}

.suggestions li:hover {
  background-color: var(--primary-color);
  color: white;
}

.base-input {
  width: 100%;
  border-radius: 0.375rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.base-input:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 0.5;
}

.base-input-light {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

.base-input-light:focus {
  --tw-border-opacity: 1;
  border-color: rgb(253 186 116 / var(--tw-border-opacity, 1));
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 215 170 / var(--tw-ring-opacity, 1));
}

.base-input-dark {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.base-input-dark:focus {
  --tw-border-opacity: 1;
  border-color: rgb(249 115 22 / var(--tw-border-opacity, 1));
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 186 116 / var(--tw-ring-opacity, 1));
}

.form-popup {
  position: absolute;
  top: 60px;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 20px;
  min-width: 300px;
  max-height: 600px;
  overflow-y: auto;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.form-popup h2 {
  margin-top: 0;
  color: var(--primary-color);
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}

.form-popup form {
  display: flex;
  flex-direction: column;
}

.form-popup input,
.form-popup select {
  margin-bottom: 15px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.form-popup button {
  cursor: pointer;
  border: none;
  padding: 0px;
  border-radius: 5px;
  font-size: 26px;
  transition: background-color 0.2s;
}

.form-popup button:hover {
  background-color: var(--primary-color);
}

.close-button {
  position: absolute;
  top: 10px;
  margin-top: 5px;
  right: 15px;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--secondary-color);
  width: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/form.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiCE;;AAEF;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAGE;EAAA,WAA4M;EAA5M,uBAA4M;EAA5M,iBAA4M;EAA5M,kBAA4M;EAA5M,4DAA4M;EAA5M,kBAA4M;EAA5M,mBAA4M;EAA5M,mBAA4M;EAA5M,sBAA4M;EAA5M,oBAA4M;EAA5M;AAA4M;;AAA5M;EAAA,sBAA4M;EAA5M,2DAA4M;EAA5M,8BAA4M;EAA5M,mBAA4M;EAA5M,2GAA4M;EAA5M,yGAA4M;EAA5M;AAA4M;;AAA5M;EAAA,sBAA4M;EAA5M,yDAA4M;EAA5M,kBAA4M;EAA5M,yDAA4M;EAA5M,oBAA4M;EAA5M;AAA4M;;AAA5M;EAAA,sBAA4M;EAA5M;AAA4M;;AAI5M;EAAA,uBAAiG;EAAjG,iBAAiG;EAAjG,sBAAiG;EAAjG,4DAAiG;EAAjG,kBAAiG;EAAjG,4DAAiG;EAAjG,+EAAiG;EAAjG,mGAAiG;EAAjG;AAAiG;;AAAjG;EAAA,sBAAiG;EAAjG,yDAAiG;EAAjG,kBAAiG;EAAjG;AAAiG;;AADnG;EAEE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAGE;EAAA,WAA6E;EAA7E,uBAA6E;EAA7E,kBAA6E;EAA7E,mBAA6E;EAA7E,mBAA6E;EAA7E,sBAA6E;EAA7E,0CAA6E;EAA7E,uDAA6E;EAA7E;AAA6E;;AAA7E;EAAA,2GAA6E;EAA7E,yGAA6E;EAA7E,4FAA6E;EAA7E;AAA6E;;AAI7E;EAAA,sBAA2F;EAA3F,4DAA2F;EAA3F,kBAA2F;EAA3F,4DAA2F;EAA3F,oBAA2F;EAA3F;AAA2F;;AAA3F;EAAA,sBAA2F;EAA3F,4DAA2F;EAA3F,oBAA2F;EAA3F;AAA2F;;AAI3F;EAAA,sBAA2F;EAA3F,yDAA2F;EAA3F,kBAA2F;EAA3F,yDAA2F;EAA3F,oBAA2F;EAA3F;AAA2F;;AAA3F;EAAA,sBAA2F;EAA3F,2DAA2F;EAA3F,oBAA2F;EAA3F;AAA2F;;AAG7F;EACE,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,WAAW;AACb","sourcesContent":["/*\n * ____   ____    .__   __\n * \\   \\ /   /___ |  |_/  |______      ____ ___.__.\n *  \\   Y   /  _ \\|  |\\   __  \\_ \\   / ___<   |  |\n *   \\     (  <_> )  |_|  |  / __ \\_/ /_/  >___  |\n *    \\___/ \\____/|____/__| (____  /\\___  // ____|\n *                               \\//_____/ \\/\n *\n * Copyright (c) 2017-2025 Voltagy. All rights reserved.\n * https://voltagy.com\n *\n * PROPRIETARY AND CONFIDENTIAL\n *\n * This source code is the proprietary and confidential property of Voltagy.\n * Unauthorized copying, transfer, or use of this file, via any medium, is\n * strictly prohibited without the express written permission of Voltagy.\n *\n * The receipt or possession of this source code and/or related information\n * does not convey or imply any right to use it, reproduce it, disclose its\n * contents, or to manufacture, use, or sell anything that it may describe.\n *\n * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS \"AS IS\"\n * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE\n * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE\n * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE\n * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR\n * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF\n * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS\n * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN\n * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)\n * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE\n * POSSIBILITY OF SUCH DAMAGE.\n *\n */\n\n.search-bar-container {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  width: 300px;\n}\n\n.search-input {\n  @apply w-full px-4 py-2 text-gray-900 bg-white border rounded-md dark:bg-gray-800 dark:text-gray-100 dark:border-gray-700 focus:border-orange-400 dark:focus:border-orange-300 focus:outline-none focus:ring;\n}\n\n.suggestions {\n  @apply bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-md shadow-lg;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  margin: 0;\n  max-height: 50vh;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: var(--primary-color) transparent;\n}\n\n.suggestions::-webkit-scrollbar {\n  width: 4px;\n}\n\n.suggestions::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.suggestions::-webkit-scrollbar-thumb {\n  background-color: var(--primary-color);\n  border-radius: 1px;\n  border: 2px solid white;\n}\n\n.suggestions li {\n  padding: 10px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  list-style-type: none;\n}\n\n.suggestions li:hover {\n  background-color: var(--primary-color);\n  color: white;\n}\n\n.base-input {\n  @apply w-full px-4 py-2 rounded-md shadow-sm focus:ring focus:ring-opacity-50;\n}\n\n.base-input-light {\n  @apply bg-white text-gray-900 border-gray-300 focus:border-orange-300 focus:ring-orange-200;\n}\n\n.base-input-dark {\n  @apply bg-gray-700 text-white border-gray-600 focus:border-orange-500 focus:ring-orange-300;\n}\n\n.form-popup {\n  position: absolute;\n  top: 60px;\n  background: white;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  padding: 20px;\n  min-width: 300px;\n  max-height: 600px;\n  overflow-y: auto;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.form-popup h2 {\n  margin-top: 0;\n  color: var(--primary-color);\n  font-size: 20px;\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n\n.form-popup form {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-popup input,\n.form-popup select {\n  margin-bottom: 15px;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.form-popup button {\n  cursor: pointer;\n  border: none;\n  padding: 0px;\n  border-radius: 5px;\n  font-size: 26px;\n  transition: background-color 0.2s;\n}\n\n.form-popup button:hover {\n  background-color: var(--primary-color);\n}\n\n.close-button {\n  position: absolute;\n  top: 10px;\n  margin-top: 5px;\n  right: 15px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--secondary-color);\n  width: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
